import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import { Helmet } from "react-helmet";
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
function Jarr(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  

return(
    <div>
 <Sides/>

 <Helmet>
 


<title>Java Array Tutorial for Beginners | CodeExampler</title>
<meta name="description" content="Learn how to declare, initialize, and manipulate arrays in Java with CodeExampler's free online tutorial. Find examples of array methods, sorting, and converting arrays to lists."/>
<meta name="keywords" content="Java array tutorial, Java array length,reverse array java,how to return an array in java,jagged array in java,Java array methods, convert array to list Java, Java array sorting, Java arraylist, Java array class"/>
<link rel="canonical" href="https://www.codeexampler.com/java-array" />

</Helmet>

<div className='lg:pl-56'>

    <h1 className="m-4 mh1">what is an array in java</h1>
    <div className="first">
        <a href="/java-continue">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-oops">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
   
    <h2 className="mt-4 mh2">Java array:</h2>
    <p className="mt-4 para">1, Array in java is a collection of similar type of data and stored in manually consecutively under one name<br/>
2, The index number will be different<br/>
3, Main purpose of array is used to handle a large volume of data of some type more easily
</p>
<h2 className="mt-4 mh2">Types of an array in java:
</h2>


<h2 className="headings">There are two types of Java array:</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
              
      {"\n"}
      <span className="qwerty-1">1,One-dimensional Array</span>
      {"\n"}
      <span className="qwerty-10">2,Multi-dimensional Array</span>
      {"\n"}
      
      {"\n"}
         </code>
          </pre>        
        </div>


<h2 className="mt-4 mh2">How Declare array in Java:
</h2>


<h2 className="headings">That is Basic Array style:</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
              
      {"\n"}
      
      <span className="qwerty-1">Ex-&#123; 20,40,30,60,50 &#125;; </span>
      {"\n"}
      {"\n"}
       </code>
          </pre>        
        </div>




<h2 className="headings">Array in Java Syntax :</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
              
      {"\n"}
      
      <span className="qwerty-10">Type </span>
      <span className="qwerty-4">array_name</span>
      <span className="qwerty-1">[</span>
        <span className="qwerty-4">size</span>
        <span className="qwerty-1">];</span>
      {"\n"}
      <span className="qwerty-1">Ex - </span>
      <span className="qwerty-10">int </span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-1">[];</span>
      {"\n"}
      <span className="qwerty-10">int </span>
      <span className="qwerty-4">b</span>
      <span className="qwerty-1">[];</span>
      {"\n"}
      {"\n"}
      

        
        
           
            </code>
          </pre>        
        </div>





<h2 className="headings">initialization array java:</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
              
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-1">[6]</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">&#123; 20,40,30,60,50 &#125;; </span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-1">[]</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">&#123; 1,2,3,5,8,10 &#125;; </span>
      {"\n"}
      {"\n"}
      

        
        
           
            </code>
          </pre>        
        </div>



<h2 className="headings">Q-how to Declare(print) the array in java?</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
              {"\n"}
              <span className="qwerty-5">class</span>
              <span className="qwerty-4"> Break_example</span>
              {"\n"}
              <span className="qwerty-3">&#123; </span>
              {"\n"}
              <span className="qwerty-7">&nbsp;&nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">main </span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-10">String</span>
              <span className="qwerty-1">[] </span>
              <span className="qwerty-9">args</span>
              <span className="qwerty-1">) </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
              {"\n"} 
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">i;</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-1">[]</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">&#123; 10,20,30,40,50 &#125;; </span>
      {"\n"}
      


      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
      <span className="qwerty-8">=</span>
      <span className="qwerty-1">0;</span>
      <span className="qwerty-4">i</span>
      <span className="qwerty-8">&#60;</span>
      <span className="qwerty-1">5;</span>
      <span className="qwerty-4">i</span>
      <span className="qwerty-8">++</span>     
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>


      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">println</span>
          <span className="qwerty-1">(</span>
            <span className="qwerty-4">a</span>
          <span className="qwerty-1">[</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-1">]</span>
          <span className="qwerty-1">);</span>
          {"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
      
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>


     
     



      {"\n"}
               
              
                <span className="qwerty-3">&#125; </span>
        
        
        
           
            </code>
          </pre>        
        </div>
        
        <div>
  <h3 className="headings">Output</h3>
  <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
    <pre style={{ maxHeight: '500vh' }}>
      <code className="python hljs">
      {"\n"}
      <span className="qwerty-9">&nbsp;10</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;30</span>
      {"\n"}     
      <span className="qwerty-9">&nbsp;500</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;700</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;900</span>
      {"\n"} 
         
        </code>{"   "}
        </pre>
  </div>
</div>




<h2 className="headings">Q- Write a Program to input an array of 10 elements and print only even elements in java array?</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
              {"\n"}
              <span className="qwerty-5">class</span>
              <span className="qwerty-4"> Array_example</span>
              {"\n"}
              <span className="qwerty-3">&#123; </span>
              {"\n"}
              <span className="qwerty-7">&nbsp;&nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">main </span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-10">String</span>
              <span className="qwerty-1">[] </span>
              <span className="qwerty-9">args</span>
              <span className="qwerty-1">) </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
              {"\n"} 
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">i;</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-1">[]</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">&#123; 10,25,30,45,50,655,700,855,900,1055 &#125;; </span>
      {"\n"}
      


      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
      <span className="qwerty-8">=</span>
      <span className="qwerty-1">0;</span>
      <span className="qwerty-4">i</span>
      <span className="qwerty-8">&#60;</span>
      <span className="qwerty-1">10;</span>
      <span className="qwerty-4">i</span>
      <span className="qwerty-8">++</span>     
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>


      {"\n"}
      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;if</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
          <span className="qwerty-1">[</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-1">]</span>
            <span className="qwerty-8">%</span>
            <span className="qwerty-1">2</span>
            <span className="qwerty-8">==</span>
            <span className="qwerty-1">0</span>
            <span className="qwerty-1">)</span>
      {"\n"}

      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>


      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">println</span>
          <span className="qwerty-1">(</span>
            <span className="qwerty-4">a</span>
          <span className="qwerty-1">[</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-1">]</span>
          <span className="qwerty-1">);</span>
          {"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
      
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>


     
     



      {"\n"}
               
              
                <span className="qwerty-3">&#125; </span>
        
        
        
           
            </code>
          </pre>        
        </div>
        
        <div>
  <h3 className="headings">Output</h3>
  <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
    <pre style={{ maxHeight: '500vh' }}>
      <code className="python hljs">
      {"\n"}
      <span className="qwerty-9">&nbsp;10</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;30</span>
      {"\n"}     
      <span className="qwerty-9">&nbsp;500</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;700</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;900</span>
      {"\n"} 
         
        </code>{"   "}
        </pre>
  </div>
</div>



<h2 className="headings">Q- Write a Program to input an array of 8 elements and print in reverse in array java?</h2>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code>
              {"\n"}
              <span className="qwerty-5">class</span>
              <span className="qwerty-4"> Program</span>
              {"\n"}
              <span className="qwerty-3">&#123; </span>
              {"\n"}
              <span className="qwerty-7">&nbsp;&nbsp;public </span>
              <span className="qwerty">static </span>
              <span className="qwerty-3">void </span>
              <span className="qwerty-8">main </span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-10">String</span>
              <span className="qwerty-1">[] </span>
              <span className="qwerty-9">args</span>
              <span className="qwerty-1">) </span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
              {"\n"} 
              {"\n"} 
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">i;</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-1">[]</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">&#123; 10, 20, 30, 40, 50, 60, 70, 80, 90, 100 &#125;; </span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
      <span className="qwerty-8">=</span>
      <span className="qwerty-1">0;</span>
      <span className="qwerty-4">i</span>
      <span className="qwerty-8">&#60;</span>
      <span className="qwerty-1">8;</span>
      <span className="qwerty-4">i</span>
      <span className="qwerty-8">++</span>     
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>


      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">println</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">a</span>
          <span className="qwerty-1">[</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-1">]</span>
          <span className="qwerty-1">);</span>
          {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">println</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">"Reverse Start"</span>
          <span className="qwerty-1">);</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
          {"\n"}
          <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;maximum</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-4">a</span>
          <span className="qwerty-1">[</span>
            <span className="qwerty-4">0</span>
            <span className="qwerty-1">];</span>
            {"\n"}
      


      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
      <span className="qwerty-8">=</span>
      <span className="qwerty-1">8;</span>
      <span className="qwerty-4">i</span>
      <span className="qwerty-8">&#62;</span>
      <span className="qwerty-1">0;</span>
      <span className="qwerty-4">i</span>
      <span className="qwerty-8">--</span>     
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>


      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">println</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">a</span>
          <span className="qwerty-1">[</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-1">]</span>
          <span className="qwerty-1">);</span>
          {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
                {"\n"}
        
               
              
                <span className="qwerty-3">&#125; </span>
        
        
        
           
            </code>
          </pre>        
        </div>
        
        <div>
  <h3 className="headings">Output</h3>
  <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
    <pre style={{ maxHeight: '500vh' }}>
      <code className="python hljs">
      {"\n"}
      <span className="qwerty-9">&nbsp;10</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;20</span>
      {"\n"}     
      <span className="qwerty-9">&nbsp;30</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;40</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;50</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;60</span>
      {"\n"}  
      <span className="qwerty-9">&nbsp;70</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;80</span>
      {"\n"}     
      <span className="qwerty-9">&nbsp;Reverse Start</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;90</span>
      {"\n"}        
      <span className="qwerty-9">&nbsp;80</span>
      {"\n"}  
      <span className="qwerty-9">&nbsp;70</span>
      {"\n"}        
      <span className="qwerty-9">&nbsp;60</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;50</span>
      {"\n"}        
      <span className="qwerty-9">&nbsp;40</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;30</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;20</span>
      {"\n"}        
      <span className="qwerty-9">&nbsp;10</span>
      {"\n"}       
        </code>{"   "}
        </pre>
  </div>
</div>


<h2 className="headings">Q-Write a Program to input an array of 10 elements and print in a Maximum no?</h2>
<div
  style={{
    background: "#0f0e33",
    width: "94%",
    marginLeft: "3%",
    paddingLeft: "2%",
    borderRadius: "20px",
  }}
>
  <pre style={{ maxHeight: "500vh" }}>
    <code>
      {"\n"}
      <span className="qwerty-5">class</span>
      <span className="qwerty-4"> Program</span>
      {"\n"}
      <span className="qwerty-3">&#123; </span>
      {"\n"}
      <span className="qwerty-7">&nbsp;&nbsp;public </span>
      <span className="qwerty">static </span>
      <span className="qwerty-3">void </span>
      <span className="qwerty-8">main </span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-10">String</span>
      <span className="qwerty-1">[] </span>
      <span className="qwerty-9">args</span>
      <span className="qwerty-1">) </span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
      {"\n"} 
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">i</span>
      <span className="qwerty-8">,</span>
      <span className="qwerty-4">maximum;</span>
      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-1">[]</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">&#123; 10, 40, 20, 80, 90, 45, 68, 60, 88, 24 &#125;; </span>
      {"\n"}
      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
      <span className="qwerty-8">=</span>
      <span className="qwerty-1">0;</span>
      <span className="qwerty-4">i</span>
      <span className="qwerty-8">&#60;</span>
      <span className="qwerty-1">10;</span>
      <span className="qwerty-4">i</span>
      <span className="qwerty-8">++</span>     
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>


      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">println</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">a</span>
          <span className="qwerty-1">[</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-1">]</span>
          <span className="qwerty-1">);</span>
          {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">println</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">"Maximum no"</span>
          <span className="qwerty-1">);</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
          {"\n"}
          <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;maximum</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-4">a</span>
          <span className="qwerty-1">[</span>
            <span className="qwerty-4">0</span>
            <span className="qwerty-1">];</span>
            {"\n"}
      


      <span className="qwerty-8">&nbsp;&nbsp;&nbsp;&nbsp;for</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">i</span>
      <span className="qwerty-8">=</span>
      <span className="qwerty-1">0;</span>
      <span className="qwerty-4">i</span>
      <span className="qwerty-8">&#60;</span>
      <span className="qwerty-1">10;</span>
      <span className="qwerty-4">i</span>
      <span className="qwerty-8">++</span>     
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>


      {"\n"}
      <span className="qwerty-6">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;if</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
          <span className="qwerty-1">[</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-1">]</span>
            <span className="qwerty-8">&#62;</span>
            <span className="qwerty-4">maximum</span>
            <span className="qwerty-1">)</span>
      {"\n"}

      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>


      {"\n"}

      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;maximum</span>
          <span className="qwerty-8">=</span>
          <span className="qwerty-4">a</span>
          <span className="qwerty-1">[</span>
            <span className="qwerty-4">i</span>
            <span className="qwerty-1">];</span>
            {"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
      
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>


      {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;&nbsp;&nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-10">println</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">maximum</span>
          <span className="qwerty-1">);</span>
          {"\n"}
     




      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"} 
      <span className="qwerty-3">&#125; </span>
        {"\n"}

       
      




   
    </code>
  </pre>        
</div>

<div>
  <h3 className="headings">Output</h3>
  <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
    <pre style={{ maxHeight: '500vh' }}>
      <code className="python hljs">
      {"\n"}
      <span className="qwerty-9">&nbsp;10</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;40</span>
      {"\n"}     
      <span className="qwerty-9">&nbsp;20</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;80</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;90</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;45</span>
      {"\n"}  
      <span className="qwerty-9">&nbsp;68</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;60</span>
      {"\n"}     
      <span className="qwerty-9">&nbsp;88</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;24</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;Maximum no</span>
      {"\n"} 
      <span className="qwerty-9">&nbsp;90</span>
      {"\n"}        
        </code>{"   "}
        </pre>
  </div>
</div>


<h1 className="mt-5"> </h1>

<div className="back">
        <a href="/java-continue">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-oops">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

        </div>

    </div>
)

}
export default Jarr;